export const LeaseListingAgentDashboardPermissions = {
  LeaseListingAgentDashboard: 
    {
      permissionsId:'e242fafe-8ed2-4445-6834-08da421d6e99',
      permissionsName :'Lease Listing Agent Dashboard',
      componentsId:null,
      components:null , 
    }
} ;
